import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";

const links = [
  { label: "Services", href: "#services", testId: "nav-services-link" },
  { label: "Reviews", href: "#reviews", testId: "nav-reviews-link" },
  { label: "Contact", href: "#contact", testId: "nav-contact-link" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 glass-header transition-shadow duration-500 ${
        scrolled ? "shadow-sm" : ""
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-12">
        <a
          href="#top"
          data-testid="logo-link"
          className="font-display text-lg font-black tracking-tight text-zinc-950"
        >
          SKY-HIGH<span className="text-sky-500">.</span>
          <span className="ml-2 hidden text-[10px] font-medium uppercase tracking-[0.3em] text-zinc-500 sm:inline">
            Window Washing
          </span>
        </a>
        <nav className="hidden items-center gap-10 md:flex" aria-label="Primary">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="group relative text-xs font-medium uppercase tracking-[0.25em] text-zinc-600 transition-colors duration-300 hover:text-zinc-950"
            >
              {link.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-sky-500 transition-[width] duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>
        <a
          href="tel:4066963771"
          data-testid="header-call-button"
          className="group flex items-center gap-2 rounded-full bg-zinc-950 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-white transition-transform duration-300 hover:scale-105 active:scale-95"
        >
          <Phone className="h-3.5 w-3.5 transition-transform duration-300 group-hover:rotate-12" />
          <span className="hidden sm:inline">406-696-3771</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </motion.header>
  );
};
